/* eslint-disable no-unused-vars */

import { Node, mergeAttributes } from "@tiptap/core";
import katex from "katex";


export const MathInline = Node.create({
    name: "mathInline",
    group: "inline",
    inline: true,
    atom: true,
  
    addAttributes() {
      return {
        latex: { default: "" }
      };
    },
  
    parseHTML() {
      return [{ tag: "span[data-math-inline]" }];
    },
  
    renderHTML({ node, HTMLAttributes }) {
      return [
        "span",
        mergeAttributes(HTMLAttributes, { "data-math-inline": "" }),
        node.attrs.latex
      ];
    },
  
    addNodeView() {
      return ({ node, getPos, editor }) => {
        const dom = document.createElement("span");
        dom.className = "math-inline-node";
        dom.style.cssText = "cursor: pointer; display: inline-block; padding: 2px 6px; border-radius: 4px; margin: 0 2px; transition: all 0.2s;";
        
        try {
          katex.render(node.attrs.latex, dom, {
            throwOnError: false,
            displayMode: false
          });
        } catch (e) {
          dom.textContent = node.attrs.latex;
        }
  
        dom.onmouseenter = () => {
          dom.style.background = "#cce5ff";
          dom.style.borderColor = "#80bdff";
        };
        dom.onmouseleave = () => {
          dom.style.background = "transparent";
          dom.style.borderColor = "transparent";
        };
  
        dom.onclick = (e) => {
          e.preventDefault();
          const pos = getPos();
          if (typeof pos === "number") {
            const event = new CustomEvent("editMath", {
              detail: { pos, latex: node.attrs.latex }
            });
            document.dispatchEvent(event);
          }
        };
  
        return { dom };
      };
    }
  });




  // Literal dollar signs (money) arrive escaped as \$ so they are not read as maths.
  const unescapeDollars = (text) => text.replace(/\\\$/g, "$");

  export function parseContentWithMath(text) {
    const regex = /(?<!\\)\$((?:\\\$|[^$])*)(?<!\\)\$/g;
    const parts = [];
    let lastIndex = 0;
    let match;
  
    while ((match = regex.exec(text)) !== null) {
      if (match.index > lastIndex) {
        parts.push({
          type: "text",
          text: unescapeDollars(text.slice(lastIndex, match.index)),
        });
      }
  
      parts.push({
        type: "mathInline",
        attrs: { latex: match[1] },
      });
  
      lastIndex = regex.lastIndex;
    }
  
    if (lastIndex < text.length) {
      parts.push({
        type: "text",
        text: unescapeDollars(text.slice(lastIndex)),
      });
    }
  
    return parts;
  }
  